import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import './index.css'
import { ThemeProvider } from './ThemeContext'
import MainLayout from './Components/MainLayout'
import LoginPage from './Components/Login'
import Dashboard from './Components/pages/Dashboard/Dashboard'
import AdminProfile from './Components/pages/AdminProfile'
import User from './Components/pages/User'
import SubAdmin from './Components/pages/SubAdmin'
import ItemManagement from './Components/pages/ItemManagement'
import Transaction from './Components/pages/Transaction'
import Report from './Components/pages/Report'
import Analytics from './Components/pages/Analytics'
import SystemLogs from './Components/pages/SystemLogs'
import PushNotification from './Components/pages/PushNotification'
import FAQs from './Components/pages/FAQs'
import Feedback from './Components/pages/Feedback'
import Setting from './Components/pages/Setting'
import Support from './Components/pages/Support'
import Subscription from './Components/pages/Subscription'
import EmailCenter from './Components/pages/EmailCenter'
import Invoice from './Components/pages/Invoice'
import WelcomeModal from './Components/common/WelcomeModal'
import Changelog from './Components/pages/Changelog'
import RolesPermissions from './Components/pages/RolesPermissions'
import CalendarPage from './Components/pages/Calendar'
import RewardsPage from './Components/pages/Rewards'
import ActivityPage from './Components/pages/Activity'
import NotesPage from './Components/pages/Notes'
import ActivityLogs from './Components/pages/Activity'

export default function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <Routes>
          <Route index element={<LoginPage />} />
          <Route element={<MainLayout />}>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<><Dashboard /><WelcomeModal /></>} />
            <Route path="admin-profile" element={<AdminProfile />} />
            <Route path="user" element={<User />} />
            <Route path="sub-admin" element={<SubAdmin />} />
            <Route path="item-management" element={<ItemManagement />} />
            <Route path="transaction" element={<Transaction />} />
            <Route path="report" element={<Report />} />
            <Route path="analytics" element={<Analytics />} />
            <Route path="system-logs" element={<SystemLogs />} />
            <Route path="push-notification" element={<PushNotification />} />
            <Route path="faqs" element={<FAQs />} />
            <Route path="feedback" element={<Feedback />} />
            <Route path="setting" element={<Setting />} />
            <Route path="support" element={<Support />} />
            <Route path="subscription" element={<Subscription />} />
            <Route path="email-center" element={<EmailCenter />} />
            <Route path="invoice" element={<Invoice />} />
            <Route path="roles" element={<RolesPermissions />} />
            <Route path="calendar" element={<CalendarPage />} />
            <Route path="rewards" element={<RewardsPage />} />
            <Route path="notes" element={<NotesPage />} />
            <Route path="activity-logs" element={<ActivityLogs />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  )
}